import { z } from 'zod';

export const createSpaceReportSchema = z.object({
  groupId: z.string().cuid().optional(),
  assignmentSetId: z.string().cuid(),
  assignmentId: z.string().cuid(),
  viewScope: z.enum(['student', 'group']).optional(),
});

const reportDetailSectionSchema = z.enum([
  'criteria',
  'constraints',
  'testing',
  'reflections',
]);

export const createSpaceReportDetailSchema = createSpaceReportSchema.extend({
  section: reportDetailSectionSchema,
  studentId: z.string().cuid(),
  iteration: z.string().regex(/^\d+$/).optional(),
  submissionId: z.string().cuid().optional(),
});

export const challengeSetReportSchema = z.object({
  assignmentSetId: z.string().cuid(),
  page: z.string().optional(),
  isReflection: z.string().optional(),
  section: z.enum(['criteria', 'constraints']).optional(),
});

export const challengeSetReportDetailSchema = z.object({
  assignmentSetId: z.string().cuid(),
  assignmentId: z.string().cuid(),
  studentId: z.string().cuid().optional(),
  section: reportDetailSectionSchema,
  iteration: z.string().regex(/^\d+$/).optional(),
  submissionId: z.string().cuid().optional(),
});
